import React from "react";
import Login from "../../components/Login/Login";

const LoginPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-r from-slate-200 to-slate-400 ...">
      <br />
      <br />
      <Login />
    </div>
  );
};

export default LoginPage;
